import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function ShiftBottomSheetShiftRequestedCard() {
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="Request sent"
      description="Sit tight — your booking request is being reviewed!"
      illustrationType="request-sent"
    />
  );
}
